import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IOccupancyFirmData } from 'types/DashboardType'
import { saveAsExcelFile } from 'utils/Miscellaneous'
import ExportBtn from './ExportBtn'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function SharedOccupancyDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [
        [
          t('most-used-words.firm'),
          t('most-used-words.location'),
          t('dashboard.num-of-coming-office'),
          t('dashboard.num-of-not-coming-office'),
          t('dashboard.total-office-notification'),
        ],
      ]

      const arr = excelData?.map((res: any) => {
        const { FirmName, LocationName, ReservationCount, IncomingCount, NotComingCount } = res || {}
        return {
          firmName: FirmName || '---',
          locationName: LocationName || '',
          incomingCount: IncomingCount,
          notComingCount: NotComingCount,
          reservationCount: ReservationCount,
        }
      })

      const totalRow = arr.reduce(
        (acc: IOccupancyFirmData, curr: IOccupancyFirmData) => {
          acc.incomingCount += curr.incomingCount || 0
          acc.notComingCount += curr.notComingCount || 0
          acc.reservationCount += curr.reservationCount || 0
          return acc
        },
        {
          firmName: '',
          locationName: t('most-used-words.total'),
          incomingCount: 0,
          notComingCount: 0,
          reservationCount: 0,
        }
      )

      let heading2 = {
        firmName: '',
        incomingCount: t('dashboard.excel.total-num-of-coming-office'),
        notComingCount: t('dashboard.excel.total-num-of-not-coming-office'),
        reservationCount: t('dashboard.excel.total-office-notification'),
      }

      arr.push(...[{}, heading2, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.shared-office-fullness'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? <ExportBtn handleExport={handleExport} /> : null}
      {children}
    </>
  )
}
